import styled from '@emotion/styled';
import React, { Fragment } from 'react';
import { VideoPlayer, VideoPlayerProps } from '../VideoPlayer/VideoPlayer';

const Frame = styled.div((props: { stretch?: boolean }) => ({
    height: props.stretch === true ? '100%' : undefined,
    position: 'relative',
} as const));

const Identifier = styled.div((props: { visible: boolean }) => ({
    position: 'absolute',
    bottom: 0,
    right: 0,
    margin: '1ex',
    color: props.visible ? 'yellow' : 'white',
    border: props.visible ? 'thin solid yellow' : 'none',
    padding: '0.2ex 0.6ex',
    borderRadius: '0.5ex',
} as const));

function SingleVideoPlayer(props: VideoPlayerProps & { name: string, visible: boolean }) {
    const { name, visible, ...otherProps } = props;
    const { stretch } = otherProps;
    return <Frame stretch={stretch}>
        <VideoPlayer {...otherProps} />
        <Identifier visible={visible}>{name}</Identifier>
    </Frame >;
}

export type VideoPlayerStreamProps = {
    id: number;
    stream?: MediaStream;
    visible: boolean;
}

export type MultipleVideoPlayerProps = Omit<VideoPlayerProps, 'stream'> & { streamProps?: VideoPlayerStreamProps[], showAllStreams?: boolean };

export function MultipleVideoPlayer(props: MultipleVideoPlayerProps) {
    const { streamProps = [], ...commonProps } = props;
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
            {
                streamProps.map(({ id, stream, visible }) =>
                    commonProps.showAllStreams || visible
                        ? <SingleVideoPlayer key={id} name={`Ch: ${id}`} {...commonProps} stream={stream} visible={visible} />
                        : <Fragment key={id} />
                )
            }
        </div>);
}
